export default {
  black: '#000000',
  blue: '#002CE2',
  red: '#FE1400',
  yellow: '#FFBB00',
  white: '#ffffff',
};
